var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';

var ScrollContainer = function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  function ScrollContainer(props) {
    _classCallCheck(this, ScrollContainer);

    var _this = _possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props));

    _this.handleWheel = _this.handleWheel.bind(_this);
    return _this;
  }

  _createClass(ScrollContainer, [{
    key: 'handleWheel',
    value: function handleWheel(e) {
      // Disable wheel scrolling in the appropriate direction when the top and
      // bottom of the container is reached. Prevents the page scrolling, without
      // affecting the menu.
      //
      // Using the wheel event instead of setting overflow:hidden on the body
      // prevents scrollbars disappearing on Macs which have the scrollbars set
      // to appear permamently, rather than only while scrolling.
      var shouldBlockUp = e.deltaY < 0 && this.ref.scrollTop === 0;
      var shouldBlockDown = e.deltaY > 0 && this.ref.scrollTop === this.ref.scrollHeight - this.ref.clientHeight;
      if (shouldBlockUp || shouldBlockDown) {
        e.preventDefault();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        {
          className: this.props.className,
          onScroll: this.handleScroll,
          onWheel: this.handleWheel,
          ref: function ref(_ref) {
            return _this2.ref = _ref;
          }
        },
        this.props.children
      );
    }
  }]);

  return ScrollContainer;
}(React.Component);

ScrollContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  handleScroll: PropTypes.func
};

var ScrollContainerWrapper = createComponent(function (theme) {
  return {
    maxHeight: theme.maxMenuHeight || '198px',
    overflowY: 'auto'
  };
}, ScrollContainer);
ScrollContainerWrapper.setDisplayName('ScrollContainerWrapper');

export default ScrollContainerWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/ScrollContainer.js
// module id = 1113
// module chunks = 1